import { jsxs as N, jsx as f } from "react/jsx-runtime";
import { I as H } from "./ic_arrowmore_fill-BlVN5kGZ.mjs";
import { createContext as Y, useContext as ee, useState as L, useMemo as F, useEffect as E, useRef as D, useCallback as V, forwardRef as P, isValidElement as te, cloneElement as re } from "react";
import { e as j } from "./extract-responsive-property-BiJ5BiwI.mjs";
import { c as S } from "./tw-cn-mXgPecoF.mjs";
import { c as v } from "./variance-DhhqoHkK.mjs";
import { o as U } from "./index-CcECYkhV.mjs";
import { I as ne } from "./ic_arrowless_fill-DCwkJEfT.mjs";
const ae = v(["relative w-full bg-static-white select-none"]), le = v(
  [
    "relative flex w-full min-h-32 py-4 px-16 items-center !truncate",
    "border border-line-neutral-weak3 overflow-hidden rounded-8",
    "placeholder:text-text-neutral-main",
    "disabled:bg-fill-neutral-weak disabled:cursor-not-allowed",
    "disabled:text-interaction-neutral-disable-main disabled:hover-never:bg-fill-neutral-weak",
    "disabled:placeholder:text-interaction-neutral-disable-main disabled:hover-never:place-holder:bg-fill-neutral-weak"
  ],
  {
    variants: {
      open: {
        true: "rounded-b-none border-b-0",
        false: ""
      },
      selected: {
        true: "!font-bold",
        false: "text-text-neutral-sub"
      },
      size: {
        small: "h-32 typography-body-12-regular pr-36",
        medium: "h-44 typography-subtitle-16-regular pr-40",
        large: "h-56 typography-subtitle-18-regular pr-44"
      },
      pcSize: {
        small: "pc:h-32 pc:typography-body-12-regular pc:pr-36",
        medium: "pc:h-44 pc:typography-subtitle-16-regular pc:pr-40",
        large: "pc:h-56 pc:typography-subtitle-18-regular pc:pr-44"
      },
      // 읽기 전용은 화살표를 내보내지 않으므로 오른쪽 여백을 왼쪽과 같은 16으로 되돌린다.
      readOnly: {
        true: "bg-fill-neutral-weak text-text-neutral-sub cursor-default caret-transparent select-text pr-16 pc:pr-16 focus-visible:border-line-neutral-main",
        false: "bg-static-white cursor-pointer hover-never:bg-interaction-neutral-presshover-weak1 active:bg-interaction-neutral-presshover-weak1"
      }
    },
    compoundVariants: [
      {
        selected: !0,
        readOnly: !1,
        class: "text-text-neutral-main"
      }
    ],
    // compoundVariants 는 값이 정확히 일치해야 맞으므로, readOnly 가 넘어오지 않으면 글자색이 비어버린다.
    defaultVariants: {
      readOnly: !1
    }
  }
), se = v("placeholder:text-text-neutral-sub", {
  variants: {
    size: {
      small: "",
      medium: "rounded-12",
      large: "rounded-16"
    },
    pcSize: {
      small: "",
      medium: "pc:rounded-12",
      large: "pc:rounded-16"
    },
    hasLeadingElement: {
      true: "pl-40",
      false: ""
    },
    hasError: {
      true: "border-line-danger-main",
      false: ""
    },
    selected: {
      true: "!font-normal",
      false: ""
    }
  },
  compoundVariants: [
    {
      hasLeadingElement: !0,
      size: "small",
      class: "pl-40"
    },
    {
      hasLeadingElement: !0,
      size: "medium",
      class: "pl-44"
    },
    {
      hasLeadingElement: !0,
      size: "large",
      class: "pl-48"
    }
  ]
}), oe = v("absolute right-16 top-1/2 size-16 -translate-y-1/2 pointer-events-none", {
  variants: {
    open: {
      true: "rotate-180",
      false: ""
    },
    size: {
      small: "size-16",
      medium: "size-20",
      large: "size-24"
    },
    pcSize: {
      small: "pc:size-16",
      medium: "pc:size-20",
      large: "pc:size-24"
    }
  }
}), ie = v("absolute left-16 top-1/2 -translate-y-1/2", {
  variants: {
    disabled: {
      true: "opacity-20",
      false: ""
    },
    // 아이콘 자체는 색을 갖지 않고(fill="currentColor") 감싸는 요소의 글자색을 그대로 쓰므로,
    // 읽기 전용일 때 디자인 가이드 색(fill/neutral/strong1)을 여기서 지정한다.
    isReadOnly: {
      true: "text-fill-neutral-strong1",
      false: ""
    }
  },
  defaultVariants: {
    disabled: !1,
    isReadOnly: !1
  }
}), de = v("mt-8 px-4 typography-body-12-regular", {
  variants: {
    hasError: {
      true: "text-text-danger-main",
      false: ""
    },
    disabled: {
      true: "text-interaction-neutral-disable-main",
      false: ""
    },
    isReadOnly: {
      true: "text-text-neutral-sub",
      false: ""
    }
  },
  compoundVariants: [
    {
      hasError: !1,
      disabled: !1,
      isReadOnly: !1,
      class: "text-text-neutral-main"
    }
  ],
  defaultVariants: {
    hasError: !1,
    disabled: !1,
    isReadOnly: !1
  }
}), _ = (r) => {
  const {
    value: a,
    size: o,
    className: i,
    label: e,
    supportText: l,
    optionalText: s,
    id: t,
    leadingElement: u,
    hasError: p = !1,
    isReadOnly: d = !1,
    ...n
  } = r, c = j({
    property: o,
    mobileKey: "size",
    pcKey: "pcSize",
    defaultValue: { mobile: "small", pc: "medium" }
  }), g = d ? !1 : p, b = ae(), h = le({
    ...c,
    selected: !!a,
    readOnly: d
  }), C = se({
    ...c,
    hasLeadingElement: !!u,
    hasError: g,
    selected: !!a
  }), O = oe({ ...c }), m = ie({
    disabled: n.disabled,
    isReadOnly: d
  }), y = de({
    ...c,
    hasError: g,
    disabled: n.disabled,
    isReadOnly: d
  });
  return /* @__PURE__ */ N("div", { className: S("relative", b, i), children: [
    e || s ? /* @__PURE__ */ N("label", { className: "mb-8 flex gap-2 px-4 text-text-neutral-main typography-body-13-semibold", htmlFor: t, children: [
      e,
      s ? /* @__PURE__ */ f("span", { className: "text-text-neutral-sub typography-body-13-regular", children: s }) : null
    ] }) : null,
    /* @__PURE__ */ N("div", { className: "relative", children: [
      /* @__PURE__ */ f(
        "input",
        {
          id: t,
          ...n,
          className: S(h, C),
          readOnly: !0,
          value: a
        }
      ),
      u ? /* @__PURE__ */ f("div", { className: S(m), children: u }) : null,
      d || n.disabled ? null : /* @__PURE__ */ f(H, { className: O })
    ] }),
    l ? /* @__PURE__ */ f("p", { className: S(y), children: l }) : null
  ] });
};
_.displayName = "NDS.SelectboxButton";
const q = Y(null);
function A() {
  const r = ee(q);
  if (r === null)
    throw new Error("useSelectContext must be used within a SelectProvider");
  return r;
}
function ce({ open: r, value: a, size: o, onChangeValue: i, onChangeOpen: e, children: l }) {
  const [s, t] = L({
    value: a,
    candidateOption: null,
    options: /* @__PURE__ */ new Map()
  }), u = j({
    property: o,
    mobileKey: "size",
    pcKey: "pcSize",
    defaultValue: { mobile: "small", pc: "medium" }
  }), p = F(
    () => ({
      onChangeOpen: e,
      onChangeValue: i,
      setOption(n, c) {
        t((g) => {
          const { options: b } = g, h = new Map(b);
          return h.set(n, { value: c }), { ...g, options: h };
        });
      },
      setCandidateOption(n) {
        t((c) => ({ ...c, candidateOption: n }));
      }
    }),
    [e, i]
  ), d = F(
    () => ({ ...s, open: !!r, ...u, ...p }),
    [s, r, p]
  );
  return E(() => {
    t((n) => ({ ...n, value: a, isOpen: !1 }));
  }, [a]), E(() => {
    r || t((n) => ({
      ...n,
      options: /* @__PURE__ */ new Map(),
      candidateOption: null
    }));
  }, [r]), /* @__PURE__ */ f(q.Provider, { value: d, children: l });
}
const ue = v(["relative w-full bg-static-white select-none"]), pe = v(
  [
    "relative flex w-full min-h-32 py-4 px-16 items-center cursor-pointer !truncate",
    "border border-line-neutral-weak3 overflow-hidden rounded-8",
    "bg-static-white text-text-neutral-main placeholder:text-text-neutral-main",
    "hover-never:bg-interaction-neutral-presshover-weak1 active:bg-interaction-neutral-presshover-weak1",
    "disabled:bg-fill-neutral-weak disabled:cursor-not-allowed",
    "disabled:text-interaction-neutral-disable-main disabled:hover-never:bg-fill-neutral-weak",
    "disabled:placeholder:text-interaction-neutral-disable-main disabled:hover-never:place-holder:bg-fill-neutral-weak"
  ],
  {
    variants: {
      open: {
        true: "rounded-b-none border-b-0",
        false: ""
      },
      selected: {
        true: "!font-bold text-text-neutral-main",
        false: "text-text-neutral-sub"
      },
      size: {
        small: "h-32 typography-body-12-regular pr-36",
        medium: "h-44 typography-subtitle-16-regular pr-40"
      },
      pcSize: {
        small: "pc:h-32 pc:typography-body-12-regular pc:pr-36",
        medium: "pc:h-44 pc:typography-subtitle-16-regular pc:pr-40"
      }
    }
  }
), be = v(
  [
    "absolute right-16 top-1/2 size-16 -translate-y-1/2 pointer-events-none",
    "aria-disabled:text-interaction-neutral-disable-main"
  ],
  {
    variants: {
      open: {
        true: "rotate-180",
        false: ""
      },
      size: {
        small: "size-16",
        medium: "size-20"
      },
      pcSize: {
        small: "pc:size-16",
        medium: "pc:size-20"
      },
      disabled: {
        true: "hidden",
        false: ""
      }
    }
  }
), me = v(
  ["absolute w-full rounded-b-8 border border-line-neutral-weak3 bg-static-white", "absolute border-t-0 "],
  {
    variants: {
      size: {
        small: "top-32",
        medium: "top-44"
      },
      pcSize: {
        small: "pc:top-32",
        medium: "pc:top-44"
      }
    }
  }
), fe = v(
  ["flex py-4 px-20 items-center cursor-pointer", "hover:bg-interaction-neutral-presshover-weak1"],
  {
    variants: {
      size: {
        small: "min-h-32 typography-body-12-regular",
        medium: "min-h-44 typography-subtitle-16-regular"
      },
      pcSize: {
        small: "pc:min-h-32 pc:typography-body-12-regular",
        medium: "pc:min-h-44 pc:typography-subtitle-16-regular"
      }
    }
  }
), K = ({ value: r, className: a, isCustom: o = !1, children: i }) => {
  const e = D(null), {
    value: l,
    candidateOption: s,
    setCandidateOption: t,
    size: u,
    pcSize: p,
    setOption: d,
    onChangeValue: n,
    onChangeOpen: c
  } = A(), g = fe({ size: u, pcSize: p }), b = l === r, h = s === e.current;
  E(() => {
    const m = e.current;
    d(m, r);
  }, [r, d]);
  const C = V(() => {
    n(r), c(!1);
  }, [r, n, c]), O = V(() => {
    const m = e.current;
    t(m);
  }, [t]);
  return /* @__PURE__ */ f(
    "li",
    {
      "aria-selected": b,
      className: o ? a : S(
        g,
        { "bg-interaction-neutral-presshover-weak1 !font-bold": b },
        { "bg-interaction-neutral-presshover-weak1": h },
        a
      ),
      onClick: C,
      onMouseEnter: O,
      ref: e,
      role: "option",
      tabIndex: -1,
      children: i
    }
  );
};
K.displayName = "NDS.DropdownOption";
const Z = P(({ className: r, style: a, children: o }, i) => {
  const { open: e, size: l, pcSize: s } = A(), t = me({ size: l, pcSize: s });
  return e ? /* @__PURE__ */ f("ul", { className: S(t, r), ref: i, style: a, children: o }) : null;
});
Z.displayName = "NDS.DropdownOptions";
const $ = P((r, a) => {
  const { onClick: o, onKeyDown: i, ...e } = r, l = D(null), { value: s, options: t, candidateOption: u, open: p, size: d, pcSize: n, setCandidateOption: c, onChangeValue: g, onChangeOpen: b } = A(), h = pe({ size: d, pcSize: n, open: p, selected: !!s }), C = be({ size: d, pcSize: n, open: p, disabled: e.disabled }), O = V(
    (y) => {
      b(!p), o == null || o(y);
    },
    [o, b, p]
  ), m = V(
    (y) => {
      if (y.preventDefault(), t.size === 0) return;
      const T = (w) => [...t].findIndex(([k]) => k === w);
      if (p)
        switch (y.code) {
          case "ArrowUp": {
            const w = T(u);
            if (w !== -1) {
              const x = (w - 1 + t.size) % t.size, k = [...t.keys()][x];
              c(k);
            } else {
              const x = [...t.keys()][0];
              c(x);
            }
            break;
          }
          case "ArrowDown": {
            const w = T(u);
            if (w !== -1) {
              const x = (w + 1) % t.size, k = [...t.keys()][x];
              c(k);
            } else {
              const x = [...t.keys()][0];
              c(x);
            }
            break;
          }
          case "Enter": {
            if (u === null) break;
            const { value: w } = t.get(u);
            g(w), b(!1);
            break;
          }
          case "Escape":
          case "Tab": {
            b(!1);
            break;
          }
        }
      else
        switch (y.code) {
          case "Enter":
          case "ArrowDown": {
            b(!0);
            break;
          }
        }
      i == null || i(y);
    },
    [t, u, p, c, i, g, b]
  );
  return /* @__PURE__ */ N("div", { className: "relative", children: [
    /* @__PURE__ */ f(
      "input",
      {
        ...e,
        className: h,
        onClick: O,
        onFocus: () => {
          var y;
          return (y = l.current) == null ? void 0 : y.blur();
        },
        onKeyDown: m,
        readOnly: !0,
        ref: U([l, a])
      }
    ),
    /* @__PURE__ */ f(H, { "aria-disabled": e.disabled, className: C })
  ] });
});
$.displayName = "NDS.DropdownTrigger";
const G = P(({ children: r, className: a }, o) => {
  const i = D(null), { open: e, onChangeOpen: l } = A(), s = ue();
  return E(() => {
    if (!e) return;
    const t = i.current, u = (p) => {
      const d = p.target;
      t.contains(d) || l(!1);
    };
    return document.addEventListener("click", u), () => {
      document.removeEventListener("click", u);
    };
  }, [e, l]), /* @__PURE__ */ f("div", { className: S(s, a), ref: U([i, o]), children: r });
});
G.displayName = "DropdownWrapper";
const J = (r) => {
  const {
    id: a,
    name: o,
    placeholder: i,
    defaultValue: e,
    value: l,
    options: s,
    required: t,
    disabled: u,
    size: p,
    optionZIndex: d = 10,
    customOptions: n,
    onFocus: c,
    onBlur: g,
    onChange: b,
    children: h,
    className: C,
    optionClassName: O
  } = r, m = D(null), y = D(null), [T, w] = L(!1), [x, k] = L(""), I = (z) => {
    w(z);
  }, R = () => {
    w(!1);
  };
  E(() => {
    const z = m.current, B = l || z.value || e || z.defaultValue;
    k(B);
  }, [l, e]), E(() => {
    var M;
    const z = m.current;
    (M = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set) == null || M.call(z, x || "");
    const X = new Event("change", { bubbles: !0 });
    z.dispatchEvent(X), z.focus();
  }, [x]);
  const W = () => s ? s.map(({ value: z, label: B }) => /* @__PURE__ */ f(K, { value: z, children: B }, z)) : n ? ge(n, R) : typeof h == "function" ? h({ onClose: R }) : h;
  return /* @__PURE__ */ f(
    ce,
    {
      size: p,
      value: x,
      open: T,
      onChangeOpen: I,
      onChangeValue: k,
      children: /* @__PURE__ */ N(G, { className: C, ref: y, children: [
        /* @__PURE__ */ f(
          $,
          {
            disabled: u,
            id: a,
            name: o,
            onBlur: g,
            onChange: (z) => {
              b == null || b(z);
            },
            onFocus: c,
            placeholder: i,
            readOnly: !0,
            ref: m,
            required: t
          }
        ),
        /* @__PURE__ */ f(Z, { className: S("overflow-hidden", O), style: { zIndex: d }, children: W() })
      ] })
    }
  );
};
function ge(r, a) {
  return r ? r.map((o, i) => {
    if (!te(o)) return o;
    const e = o, l = e.props.onClick;
    return re(e, {
      onClick: (s) => {
        l == null || l(s), a();
      },
      key: e.key ?? i
    });
  }) : null;
}
J.displayName = "NDS.Dropdown";
const he = v(
  ["relative overflow-hidden", "border border-solid border-line-neutral-weak3", "rounded-b-8", "gap-4"],
  {
    variants: {
      isOpen: {
        true: "border-2 border-line-neutral-main border-t-0",
        false: ""
      }
    },
    defaultVariants: {
      isOpen: !1
    }
  }
), ye = v(["relative typography-subtitle-16-regular"], {
  variants: {
    isOpen: {
      true: "rounded-b-none",
      false: ""
    },
    disabled: {
      true: "!font-bold text-text-neutral-main",
      false: "text-text-neutral-sub"
    }
  }
}), xe = v(
  [
    "relative flex w-full min-h-44 py-4 px-16 items-center cursor-pointer",
    "border border-line-neutral-weak3 overflow-hidden rounded-8",
    "typography-subtitle-16-regular",
    "bg-static-white text-text-neutral-main placeholder:text-text-neutral-main",
    "hover-never:bg-interaction-neutral-presshover-weak1 active:bg-interaction-neutral-presshover-weak1",
    "text-left",
    "disabled:bg-fill-neutral-weak disabled:cursor-not-allowed disabled:active:bg-fill-neutral-weak disabled:active:cursor-not-allowed",
    "disabled:text-interaction-neutral-disable-main disabled:hover-never:bg-fill-neutral-weak",
    "disabled:placeholder:text-interaction-neutral-disable-main disabled:hover-never:place-holder:bg-fill-neutral-weak"
  ],
  {
    variants: {
      isAccent: {
        true: "border-2 border-line-neutral-main",
        false: ""
      },
      isOpen: {
        true: "rounded-b-none border-2 border-line-neutral-main border-b-0",
        false: "before:hidden"
      },
      disabled: {
        true: "cursor-not-allowed",
        false: ""
      },
      hasDivider: {
        true: "before:absolute before:bottom-0 before:left-0 before:h-1 before:w-full before:bg-fill-neutral-weak3",
        false: ""
      }
    },
    defaultVariants: {
      isOpen: !1
    }
  }
), ve = v(
  ["aria-disabled:text-interaction-neutral-disable-main", "ml-auto shrink-0", "size-20"],
  {
    variants: {
      isOpen: {
        true: "",
        false: "rotate-180"
      },
      disabled: {
        true: "hidden",
        false: ""
      }
    }
  }
), we = v(["mr-8 break-words"], {
  variants: {
    selected: {
      true: "text-text-neutral-main typography-subtitle-16-bold",
      false: "text-text-neutral-sub"
    },
    isAccent: {
      true: "",
      false: ""
    },
    disabled: {
      true: "cursor-not-allowed text-interaction-neutral-disable-main",
      false: ""
    },
    disabledAccent: {
      true: ["border-line-neutral-weak3 bg-fill-neutral-weak1", "text-text-neutral-sub typography-subtitle-16-bold"],
      false: ""
    }
  },
  defaultVariants: {
    //
  }
}), Q = P(
  ({
    value: r,
    isOpen: a,
    placeholder: o = "선택해 주세요",
    className: i,
    onClick: e,
    zIndex: l,
    isDisabled: s,
    isAccent: t,
    textClassName: u,
    needDisabledAccent: p,
    hasDivider: d
  }, n) => {
    const c = l ? `z-${l}` : "z-1", g = xe({
      isOpen: a,
      isAccent: t,
      disabled: s,
      hasDivider: d
    }), b = we({
      selected: !!r,
      disabled: s,
      isAccent: t,
      disabledAccent: p
    }), h = ve({ isOpen: a, disabled: s });
    return /* @__PURE__ */ N(
      "button",
      {
        "aria-expanded": a,
        "aria-haspopup": "listbox",
        className: S(g, i, c),
        disabled: s,
        onClick: e,
        ref: n,
        type: "button",
        children: [
          /* @__PURE__ */ f("span", { className: S(b, u), children: r || o }),
          /* @__PURE__ */ f(ne, { className: S(h) })
        ]
      }
    );
  }
);
Q.displayName = "PullDownTrigger";
const ke = ({
  children: r,
  value: a,
  isOpen: o,
  defaultOpen: i = !1,
  onOpenChange: e,
  placeholder: l = "선택해 주세요",
  triggerClassName: s,
  triggerContentClassName: t,
  contentClassName: u,
  wrapperClassName: p,
  disabled: d,
  isClosable: n = !1,
  isAccent: c = !1,
  needDisabledAccent: g,
  hasDivider: b
}) => {
  const [h, C] = L(i), O = o !== void 0, m = O ? o : h, y = D(null), T = ye({ isOpen: m, disabled: d }), w = he({ isOpen: m }), x = V(
    (k) => {
      d || !n && m || (O ? e == null || e(k) : C(k));
    },
    [m, e, d, n, O]
  );
  return E(() => {
    if (!m || !n) return;
    const k = y.current, I = (R) => {
      const W = R.target;
      k.contains(W) || x(!1);
    };
    return document.addEventListener("click", I), () => {
      document.removeEventListener("click", I);
    };
  }, [m, n, x]), /* @__PURE__ */ N("div", { className: S(T, p), ref: y, children: [
    /* @__PURE__ */ f(
      Q,
      {
        className: s,
        hasDivider: b,
        isAccent: c,
        isDisabled: d,
        isOpen: m,
        needDisabledAccent: g,
        onClick: () => {
          x(!m);
        },
        placeholder: l,
        textClassName: t,
        value: a
      }
    ),
    m ? /* @__PURE__ */ f("div", { className: S(w, u), children: r }) : null
  ] });
}, Ve = {
  Dropdown: J,
  DropdownOption: K,
  Button: _,
  PullDown: ke
};
export {
  Ve as Selectbox,
  _ as SelectboxButton
};
